var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center",attrs:{"cols":"2"}},[_c('i',{class:_vm.classHandler,attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }